module.exports = __webpack_public_path__ + "img/entia-portafolio-infraestructura-carrusel-5.5d7175e5.webp";